<template>
	<section class="app-config-protocol-wrap" v-loading="isLoading">
		<div v-if="protocolData">
			<!-- 用户协议 -->
			<div class="label-box">
				<div>
					<LableTitle title='用户服务协议' num='1' :showTitleUser="true"></LableTitle>
				</div>
				<div class="flex-box">
					<j-editor @handleEditContent="handleEditContent"
						@handleSettingEditContent="handleSettingEditContent"
						type='CUSTOMER_SERVICE_PROTOCOL'></j-editor>
				</div>
			</div>
			<!-- 使用帮助 -->
			<div class="label-box">
				<LableTitle title='隐私政策协议' num='2' :showTitleProduct="true"></LableTitle>
				<div class="flex-box">
					<j-editor @handleEditContent="handleEditContent"
						@handleSettingEditContent="handleSettingEditContent" type='PRIVACY_POLICY_PROTOCOL'></j-editor>
				</div>
			</div>
			<div class="bottom-operate">
				<el-button @click="handerClose()" style="margin-top:100px">返回</el-button>
				<el-button type="primary" @click="modifyConfig">提交</el-button>
			</div>
		</div>
	</section>
</template>

<script>
import _api from "@/utils/request";
import { http } from "../../../../utils/request/newIndex"
import LableTitle from './label-title.vue'
import editor from './editor'
export default {
	data() {
		return {
			protocolData: {},
			list: {},
			isLoading: false,
			updata: {
				"modifySysStaticConfigVo": []
			},
		}
	},
	created() {
		this.getProtocolConfig()
	},
	methods: {
		getProtocolConfig() {
			this.isLoading = true
			this.protocolData = {}
			const vo = {
				"keys": [],
				"module": 'protocol'
			}
			http.getConfig(vo).then(res => {
				this.isLoading = false
				if (res.code === 1) {
					console.log(res.data)
					res.data.forEach(key => {
						this.protocolData[key.sysKey] = key.sysValue
						this.updata.modifySysStaticConfigVo.push({
							"key": key.sysKey,
							"value": key.sysValue,
						})
					})
					this.$forceUpdate()
					console.log(this.protocolData,this.updata.modifySysStaticConfigVo)
				}
			})
		},
		handerClose() {
			this.$router.go(-1)
		},
		// 修改配置
		modifyConfig() {
			console.log(this.protocolData,"this.protocolDatavthis.protocolData");
			this.updata.modifySysStaticConfigVo[0].value = this.protocolData.CUSTOMER_SERVICE_PROTOCOL
			this.updata.modifySysStaticConfigVo[1].value =this.protocolData.PRIVACY_POLICY_PROTOCOL 
			http.updateConfig(this.updata).then(res => {
				this.isLoading = false
				if (res.code === 1) {
					this.$message.success('提交成功')
				}
			})
		},
		handleEditContent(html, type) {
			console.log(html, "html");
			this.protocolData[type] = html
			console.log(this.protocolData);
			this.$forceUpdate()
		},
		handleSettingEditContent(set, type) {
			setTimeout(() => {
				if (type === "CUSTOMER_SERVICE_PROTOCOL") {
					console.log('handleSettingEditContent', this.protocolData)
					set.html(this.protocolData.CUSTOMER_SERVICE_PROTOCOL)
				} else {
					set.html(this.protocolData.PRIVACY_POLICY_PROTOCOL)
				}
			}, 300)
		},

	},

	components: {
		LableTitle,
		[editor.name]: editor
	}
}
</script>
<style lang="scss" scoped>
.app-config-protocol-wrap {
	.label-box {
		margin-bottom: 40px;
	}

	.flex-box {
		display: flex;
		padding-left: 100px;
		width: 1000px;
	}

	.bottom-operate {
		// border-top: 1px solid #ccc;
		padding: 20px 200px 60px;

		/deep/.el-button {
			padding: 8px 13px;
		}
	}
}
</style>
